// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2-LNh","label":"Completed_label__2-go8"};